import { useMemo } from 'react';

export interface PlaceEntity {
  occupied?: boolean;
  blocked?: boolean;
}

export interface PlaceStats {
  total: number;
  occupied: number;
  empty: number;
  blocked: number;
  occupiedRate: number;
  blockedRate: number;
}

export function calculatePlaceStats(entities: PlaceEntity[]): PlaceStats {
  let occupied = 0;
  let blocked = 0;
  let empty = 0;

  for (const entity of entities) {
    if (entity.occupied) occupied++;
    if (entity.blocked) blocked++;
    if (!entity.occupied && !entity.blocked) empty++;
  }

  const total = entities.length;

  return {
    total,
    occupied,
    empty,
    blocked,
    occupiedRate: total > 0 ? Number(((occupied / total) * 100).toFixed(2)) : 0,
    blockedRate: total > 0 ? Number(((blocked / total) * 100).toFixed(2)) : 0,
  };
}

export function usePlaceStats(entities: PlaceEntity[]): PlaceStats {
  return useMemo(() => calculatePlaceStats(entities), [entities]);
}
